// Auto-generated normalizer for table: Empleados_ZonasGeograficas
export function empleadosZonasGeograficasNormalize(row) {
  return {
    idEmpleadoZona: row.idEmpleadoZona ?? row.IdEmpleadoZona ?? row['IdEmpleadoZona'] ?? 0,
    idEmpleado: row.idEmpleado ?? row.IdEmpleado ?? row['IdEmpleado'] ?? 0,
    idZonaGeografica: row.idZonaGeografica ?? row.IdZonaGeografica ?? row['IdZonaGeografica'] ?? 0,
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
    fechaAsignacion: row.fechaAsignacion ?? row.FechaAsignacion ?? row['FechaAsignacion'] ?? null,
  };
}
